import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UtilityService } from '../../services';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-file-input',
  templateUrl: './file-input.component.html',
  styles: ['.hint{font-size:0.8rem; opacity:0.7}']
})
export class FileInputComponent {

  @Input() label;
  @Input() accept = 'image/*';
  @Input() type = 'Image';
  @Input() hint = '';
  @Input() isEditable = false;
  @Input() baseUrl = 'cityprofile';
  @Input() isRemoveFromAPI = false;
  @Input() fileControl: FormControl;
  @Input() apiFilePath: FormControl;
  @Input() fileName: FormControl;
  @Output() triggerRemove = new EventEmitter<any>();

  constructor(private util: UtilityService) { }

  onSelectedFile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('file', file);
      // this.city.uploadPhoto(formData, this.baseUrl).subscribe(
      //   res => {
      //     if (res.data) {
      //       this.fileName.setValue(res.data);
      //     } else {
      //       this.util.showMsg('Something went Wrong', 'Error');
      //     }
      //   }, err => { this.util.errorMessage(err); }
      // );
    } else {
      this.fileName.setValue('');
    }
  }
  removeFile() {
    this.util.confirm(`Remove ${this.type}`, `Are you sure want to remove this ${this.type}?`)
      .pipe(take(1)).subscribe(confirmed => {
        if (confirmed) { this.remove(); }
      });
  }
  remove() {
    if (this.apiFilePath && this.isRemoveFromAPI) {
      this.triggerRemove.emit();
    }
    this.fileName.setValue('');
    this.apiFilePath.setValue('');
  }
}
